// Many API URLs use the 'current' value instead of a season to get the most up-to-date data.
export const CURRENT = 'current';

// Beginning with this season, player headshots are guaranteed to use the modern format (update: maybe not)
export const MODERN_HEADSHOT_ERA = 20152016;

// d3 Player Search Endpoint
export const D3_PLAYER_SEARCH = 'https://search.d3.nhle.com/api/v1/search/player';

export const D3_CONTENT_SEARCH = `https://forge-dapi.d3.nhle.com/v2/content/${
    window.__SITE_SETTINGS__?.localeCode.toLocaleLowerCase() || 'en'
}`;

export const FAKE_TBD_TEAM_ID = -1;

// To keep the frontend up-to-date, we'll reduce the polling interval from 10 minutes to just 2 minutes
// We use this polling time when we don't know when games will be going live.
export const SHORT_DEFAULT_POLLING_TIME = {
    defaultPollTime: 120 * 1000, // 2 minutes
};
